import { FC } from 'react'

import Button from 'components/forms/Button'
import imageResize, { generateSrcSet } from 'project/image-proxy-web'
import useWindowSize from 'components/util/useWindowSize'
import Link from 'next/link'
import classNames from 'classnames'
import Strings from 'project/localisation'
import { Constants } from 'common/utils'

type Props = {}

const ContactUsCard: FC<Props> = () => {
  const size = useWindowSize()
  return (
    <div className='card overflow-hidden'>
      <div className='d-flex flex-column flex-lg-row h-100'>
        <div className='d-flex flex-1 flex-column ps-4 ps-lg-12 pt-11 pb-lg-3'>
          <div style={{ marginRight: size.isLgOrHigher ? '-20%' : undefined }}>
            <h2
              style={{
                marginRight: size.isLgOrHigher ? '-62%' : undefined,
              }}
              className='fw-semibold lh-114 fs-fluid-40-48'
            >
              Our Central London address:
            </h2>

            <span className='fs-fluid-18-24 fw-semibold pt-2 pb-6 lh-140'>
              {Constants.companyInformation.address2},
              <br />
              {Constants.companyInformation.address3},
              <br />
              {Constants.companyInformation.city} {Constants.companyInformation.postal_code}
              <br />
              <a
                className={classNames(
                  'text-link-pink',
                  size.isMdOrLower ? 'text-underline' : '',
                )}
                href='https://g.page/HoxtonMix?share'
                target='_blank'
                rel={'noopener noreferrer'}
              >
                {Strings.directions}
              </a>
              {/*always 22px*/}
            </span>
            <Link href='/contact-us'>
              <Button
                theme='secondary'
                className='align-self-lg-start w-lg-auto w-100 mt-4'
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </div>

        <div
          style={{
            width: size.isLgOrHigher ? '70%' : '100%',
          }}
          className='d-flex align-self-end align-items-center align-items-lg-end justify-content-center justify-content-lg-end h-100'
        >
          {size.isLgOrHigher ? (
            <img
              {...generateSrcSet(
                '/images/new/robot-upperhalf-half-head.png',
                506,
                764,
              )}
              alt='robot upper head'
              className='img-fluid'
              height={764}
              width={506}
              loading='lazy'
            />
          ) : (
            <img
              {...generateSrcSet('/images/new/robot-head-small.png', 361, 209)}
              alt='robot upper head'
              className='w-100 h-auto rounded-bottom-img'
              height={209}
              width={361}
              loading='lazy'
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ContactUsCard
